/**
 *
 * MyAccountLayout
 *
 */
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from 'app/components/common/Header';
import { AccountSettingsSidebar } from './Sidebar';

interface Props {}

export const AccountSettingsLayout = (props: Props) => {
  return (
    <React.Fragment>
      <Header notifications={[]} />
      <div className="flex-1 pt-[6.5rem]">
        <div className="overflow-hidden p-6">
          <div className="flex gap-6 h-[calc(100vh-9.5rem)] p-6 bg-white rounded-lg">
            <AccountSettingsSidebar />
            <div className="overflow-y-auto flex-1 min-w-0 custom-scrollbar">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
